import { GlSprintf, GlModal } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../alert.js?vue3';
import axios from '../../lib/utils/axios_utils.js?vue3';
import { visitUrl, getParameterByName } from '~/lib/utils/url_utility';
import { stripQuotes } from '~/lib/utils/text_utility';
import { s__, __, sprintf } from '~/locale';
export default {
    name: 'PromoteLabelModal',
    primaryProps: {
        text: s__('Labels|Promote Label'),
        attributes: {
            variant: 'confirm'
        }
    },
    cancelProps: {
        text: __('Cancel')
    },
    components: {
        GlModal,
        GlSprintf
    },
    props: {
        url: {
            type: String,
            required: true
        },
        labelTitle: {
            type: String,
            required: true
        },
        labelColor: {
            type: String,
            required: true
        },
        labelTextColor: {
            type: String,
            required: true
        },
        groupName: {
            type: String,
            required: true
        }
    },
    computed: {
        text () {
            return sprintf(s__(`Labels|Promoting %{labelTitle} will make it available for all projects inside %{groupName}.
        Existing project labels with the same title will be merged. If a group label with the same title exists,
        it will also be merged. This action cannot be reversed.`), {
                labelTitle: this.labelTitle,
                groupName: this.groupName
            });
        },
        cleanedLabelColor () {
            return stripQuotes(this.labelColor);
        },
        cleanedLabelTextColor () {
            return stripQuotes(this.labelTextColor);
        }
    },
    methods: {
        onSubmit () {
            return axios.post(this.url, {
                params: {
                    format: 'json'
                },
                page: getParameterByName('page')
            }).then((response)=>{
                visitUrl(response.data.url);
            }).catch((error)=>{
                createAlert({
                    message: error
                });
            });
        }
    }
};
